module.exports = __webpack_public_path__ + "img/banner-country.e2d03c7b.png";